import React, { useEffect, useState } from "react";
import { useFetchAdsByAddressQuery } from "../../store";
import { Ad } from "../../types";

interface AdsCarouselProps {
  address: string;
}

const AdsCarouselWrapper: React.FC<AdsCarouselProps> = ({ address }) => {
  const {
    data: ads,
    isFetching,
    isLoading,
  } = useFetchAdsByAddressQuery(address);

  if (isLoading || isFetching || !ads || ads.length === 0) {
    return null;
  }

  return <AdsCarousel ads={ads} />;
};

const AdsCarousel: React.FC<{ ads: Ad[] }> = ({ ads }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % ads.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [ads.length]);

  return (
    <div className="relative w-full max-w-[90%] lg:max-w-[80%] mx-auto overflow-hidden rounded-xl shadow-lg mt-4">
      <div className="relative">
        <img
          src={ads[currentIndex].imagePath}
          alt="ad-active"
          className="w-full h-auto object-cover opacity-0 pointer-events-none"
        />

        {ads.map((ad, index) => (
          <img
            key={ad._id}
            src={ad.imagePath}
            alt="ad"
            className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-700 ease-in-out ${
              index === currentIndex ? "opacity-100" : "opacity-0"
            }`}
          />
        ))}
      </div>

      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 bg-black/30 px-2 py-1 rounded-full z-10">
        {ads.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-2.5 h-2.5 rounded-full transition-all ${
              index === currentIndex ? "bg-white scale-110" : "bg-white/50"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default AdsCarouselWrapper;
